// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  MessageEdit,
  Message2,
  Calendar1,
  Kanban,
  TableDocument,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  Setting2,
  MedalStar
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  Setting: Setting2,
  CreateBlog: Message2,
  Blog: MessageEdit,
  emailTemplate: TableDocument,
  certificate: MedalStar
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //
const CertificateTemplate: NavItemType = {
  id: 'certificate',
  // title: <FormattedMessage id="Settings" />,
  icon: icons.applications,
  type: 'group',
  name: 'Certificates',
  children: [
    {
      id: 'certificate',
      title: <FormattedMessage id="Certificate Templates" />,
      type: 'item',
      url: '/certificate',
      icon: icons.certificate,
      breadcrumbs: false
    }
  ]
};

export default CertificateTemplate;
